import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useEffect } from "react";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { ScrollAreaScrollbarAuto } from "./auth-service-tools545.js";
import { ScrollAreaScrollbarHover } from "./auth-service-tools546.js";
import { ScrollAreaScrollbarScroll } from "./auth-service-tools547.js";
import { ScrollAreaScrollbarVisible } from "./auth-service-tools548.js";
const ScrollAreaScrollbar = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    forceMount,
    ...scrollbarProps
  } = props;
  const context = useScrollAreaContext();
  const {
    onScrollbarXEnabledChange,
    onScrollbarYEnabledChange
  } = context;
  const isHorizontal = props.orientation === "horizontal";
  useEffect(() => {
    isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
    return () => {
      isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
    };
  }, [isHorizontal, onScrollbarXEnabledChange, onScrollbarYEnabledChange]);
  return context.type === "hover" ? /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarHover, { ...scrollbarProps,
    ref: forwardedRef,
    forceMount
  }) : context.type === "scroll" ? /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarScroll, { ...scrollbarProps,
    ref: forwardedRef,
    forceMount
  }) : context.type === "auto" ? /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarAuto, { ...scrollbarProps,
    ref: forwardedRef,
    forceMount
  }) : context.type === "always" ? /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarVisible, { ...scrollbarProps,
    ref: forwardedRef
  }) : null;
});
ScrollAreaScrollbar.displayName = "@mantine/core/ScrollAreaScrollbar";
export { ScrollAreaScrollbar };